/*
* Tools.js
*
* Various support functions
*/


/*
* Reverses string to be year.month.day hours:minutes
*/
function ReverseDateString(p_string) {

  var date_and_time = p_string.split(' ');
  var date_parts = date_and_time[0].split('.');
  
  var l_return_string = date_parts[2] + '.' + date_parts[1] + '.' + date_parts[0];
  if( date_and_time[1] !== undefined ) {
    l_return_string += date_and_time[1];
  }
  return l_return_string;
}

/*
* Takes a date object and returns a string version of the full date as dd.mm.yyyy hh:mm
*/
function GetFullDate( p_date ) {
  var l_date_str = StringifyDate( p_date.getDate() ) + '.' + StringifyDate( p_date.getMonth()+1 ) + '.' + p_date.getFullYear()  + ' ' + StringifyDate( p_date.getHours() ) + ':' + StringifyDate( p_date.getMinutes() )
    + ':' + StringifyDate( p_date.getSeconds() );
  return l_date_str;
}

/*
* Takes a date object and returns the date part as dd.mm.yyyy
*/
function GetDate( p_date ) {
  var l_date_str = StringifyDate( p_date.getDate() ) + '.' + StringifyDate( p_date.getMonth()+1 ) + '.' + p_date.getFullYear();
  return l_date_str;
}

/*
* Takes a date object and returns the time part as hh:mm
*/
function GetTime( p_date ) {
  var l_date_str = StringifyDate( p_date.getHours() ) + ':' + StringifyDate( p_date.getMinutes() );
  return l_date_str;
}

function GetDateTime( p_date ) {
  var l_date_str = StringifyDate( p_date.getDate() ) + '.' + StringifyDate( p_date.getMonth()+1 ) + '.' + p_date.getFullYear()  + ' ' + StringifyDate( p_date.getHours() ) + ':' + StringifyDate( p_date.getMinutes() );
  return l_date_str;
}

function StringifyDate( p_date_part ) {
  if( p_date_part < 10 )
    return '0' + p_date_part;
  else
    return p_date_part;
}

/*
* Sets an element to only allow numbers and certain editing keypresses
*/
function SetInputNumbersOnly( p_element_id ) {
  var $element = $(p_element_id);
  $element.blur(function(){

    var num = parseInt($element.val());

    if(isNaN(num))
      $element.val('');
  });

}

function CalculatePresentageOfTotal(total, value, includePresentage){
  return !includePresentage ? ((value/total) * 100) + '%' : ((value/total) * 100);
}
